//import React from 'react';
import ReactDOM from 'react-dom/client';
import React, { useState, useEffect } from "react";
import './index.css';
import Home from './pages/index.jsx';
import Objinfo from './pages/objinfo.jsx'
import reportWebVitals from './reportWebVitals';
import LoginPage from "./pages/LoginPage";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import NewCity from "./pages/NewCity.js"
import NewUser from "./pages/NewUser.js"
import LandingPage from './pages/LandingPage.js';
import AddLayer from './pages/addlayer.jsx';
import NewBimObj from './pages/NewBimObj.jsx';
import AddInfo from './pages/addinfo.jsx';
import AddAll from './pages/addall.jsx';
import AddVal from './pages/addval.jsx';
import AddImg from './pages/addimg.jsx';
import DeleteTable from './pages/DeleteData.jsx';
import XKTViewer from './pages/xktviewer.jsx';
import PoiTable from './pages/poitable.js';

/*
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
*/

function App()
{
  const [user, setUser] = useState(null);
  const [password, setPass] = useState(null);
  const [bearer, setBea] = useState(null);
  return(
    <Router>
        <Routes>
          /*<Route path="/"  element={<Home />} />*/
          
        <Route path="/" element={user ? <LandingPage user={user}  setUser={setUser} bearer={bearer}  setBea={setBea} /> : <Navigate to="/login" />} />
        <Route path="/login" element={<LoginPage setUser={setUser} setBea={setBea} setPass={setPass}/>} />
        <Route path="/objinfo/:id" element={<Objinfo />} />
        <Route path="/xktviewer/:id/:url/:desc"element={<XKTViewer />}/>
        <Route path="/poitable" element={<PoiTable />}/>
        <Route
          path="/landingpage"
          element={user ? <LandingPage user={user}  setUser={setUser} bearer={bearer}  setBea={setBea} /> : <Navigate to="/login" />}
        />
         <Route
          path="/newcity"
          element={user ? <NewCity user={user}  setUser={setUser}  bearer={bearer} setBea={setBea}/> : <Navigate to="/landingpage" />}
        />
        
         <Route
          path="/newbimobj"
          element={user ? <NewBimObj user={user}  setUser={setUser}  bearer={bearer} setBea={setBea}/> : <Navigate to="/landingpage" />}
        />
        
         <Route
          path="/addinfo"
          element={user ? <AddInfo user={user}  setUser={setUser}  bearer={bearer} setBea={setBea}/> : <Navigate to="/landingpage" />}
        />
        
         <Route
          path="/addall"
          element={user ? <AddAll user={user}  setUser={setUser}  bearer={bearer} setBea={setBea}/> : <Navigate to="/landingpage" />}
        />
         <Route
          path="/addval"
          element={user ? <AddVal user={user}  setUser={setUser}  bearer={bearer} setBea={setBea}/> : <Navigate to="/landingpage" />}
        />
        
         <Route
          path="/addlayer"
          element={user ? <AddLayer user={user}  setUser={setUser}  bearer={bearer} setBea={setBea}/> : <Navigate to="/landingpage" />}
        />
        
         <Route
          path="/addimg"
          element={user ? <AddImg user={user}  setUser={setUser}  bearer={bearer} setBea={setBea}/> : <Navigate to="/landingpage" />}
        />
        
       <Route
          path="/newuser"
          element={user ? <NewUser user={user}  setUser={setUser}  bearer={bearer} setBea={setBea}/> : <Navigate to="/landingpage" />}
        />
        <Route
          path="/delete"
          element={user ? <DeleteTable  user={user}  setUser={setUser}  bearer={bearer} setBea={setBea}/> : <Navigate to="/landingpage" />}
        />
        
       


        </Routes>
    </Router>
  )
}

export default App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);